import React, { Component } from 'react';
import TabsHeader from './TabsHeader.js';
import { TabsContainer } from './styles/common.js';
class Tabs extends Component {
    constructor() {
        super(...arguments);
        this.onMouseUp = (e) => {
            e.currentTarget.blur();
        };
        this.onClick = (e) => {
            this.props.onClick(e.currentTarget.value);
        };
    }
    renderTabs() {
        const tabs = this.props.tabs;
        const selected = this.props.selected;
        return tabs.map((tab, i) => {
            let isSelected;
            const value = typeof tab.value !== 'undefined' ? tab.value : tab.name;
            if (value === selected) {
                isSelected = true;
                if (tab.component) {
                    this.SelectedComponent = tab.component;
                    if (tab.selector)
                        this.selector = () => tab.selector(tab);
                }
            }
            return (React.createElement("button", { key: i, value: value, "data-selected": isSelected, onMouseUp: this.onMouseUp, onClick: this.onClick }, tab.name));
        });
    }
    render() {
        const tabsHeader = (React.createElement(TabsHeader, { tabs: this.renderTabs(), items: this.props.tabs, main: this.props.main, collapsible: this.props.collapsible, onClick: this.props.onClick, selected: this.props.selected, position: this.props.position }));
        if (!this.SelectedComponent) {
            return (React.createElement(TabsContainer, { position: this.props.position }, tabsHeader));
        }
        return (React.createElement(TabsContainer, { position: this.props.position },
            tabsHeader,
            React.createElement("div", null,
                React.createElement(this.SelectedComponent, { ...(this.selector && this.selector()) }))));
    }
}
Tabs.defaultProps = { position: 'left' };
export default Tabs;
